'use strict';

var floydWarshall = require('ml-floyd-warshall');
var Matrix = require('ml-matrix');

module.exports = function (OCL) {
    return function getConnectivityMatrix() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.ensureHelperArrays(OCL.Molecule.cHelperNeighbours);
        var nbAtoms = this.getAllAtoms();
        var i, j, l;
        var result = new Array(nbAtoms).fill();
        result = result.map(function () {
            return new Array(nbAtoms).fill(0);
        });

        if (!options.pathLength) {
            if (options.atomicNo) {
                for (i = 0; i < nbAtoms; i++) {
                    result[i][i] = this.getAtomicNo(i);
                }
            } else if (options.mass) {
                for (i = 0; i < nbAtoms; i++) {
                    result[i][i] = OCL.Molecule.cRoundedMass[this.getAtomicNo(i)];
                }
            } else {
                for (i = 0; i < nbAtoms; i++) {
                    result[i][i] = 1;
                }
            }
        }

        if (options.sdt) {
            for (i = 0; i < nbAtoms; i++) {
                l = this.getAllConnAtoms(i);
                for (j = 0; j < l; j++) {
                    result[i][this.getConnAtom(i, j)] = this.getConnBondOrder(i, j);
                }
            }
        } else {
            for (i = 0; i < nbAtoms; i++) {
                l = this.getAllConnAtoms(i);
                for (j = 0; j < l; j++) {
                    result[i][this.getConnAtom(i, j)] = 1;
                }
            }
        }

        if (options.pathLength) {
            result = floydWarshall(new Matrix(result)).to2DArray();
        }

        return result;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/openchemlib-extended/lib/extend/getConnectivityMatrix.js
// module id = 51
// module chunks = 0